import { set } from 'cerebral/operators'
import { state, props, string } from 'cerebral/tags'
import hideTreeContextMenu from './hideTreeContextMenu'
import showDialog from 'modules/App/factories/showDialog'

export default [
  ...hideTreeContextMenu,
  set(state`node.deleteNode`, props`path`),
  set(props`node`, state`${props`path`}`),
  showDialog({
    type: 'confirm',
    title: {
      key: 'bms.node.dialog.deleteNode.title'
    },
    content: {
      key: 'bms.node.dialog.deleteNode.content',
      params: {
        node: string`${props`node.name`}`
      }
    },
    confirm: {
      signal: 'node.deleteNode',
      args: {}
    }
  })
]



// WEBPACK FOOTER //
// ./src/modules/Node/chains/prepareRemoveNode.js